// extracted by mini-css-extract-plugin
export default {"loading-container":"styles-scoped__loading-container--GJaYA","loadingContainer":"styles-scoped__loading-container--GJaYA"};